module.exports = __webpack_public_path__ + "media/images/diversity-hero-1-e1ffd2a2bb48a86de4498cf87fa6d15b.png";